import styled from 'styled-components/macro'
import { EroDarkEastSVG } from 'src/components/Icons/Brand'

export const CheckWithEroIcon = styled(EroDarkEastSVG)<{
  $isDisabled?: boolean
  height?: string
  width?: string
}>`
  height: ${({ height }) => (height ? `${height}` : '1.7em')};
  width: ${({ width }) => (width ? `${width}` : '1.7em')};
  path {
    opacity: ${({ $isDisabled }) => ($isDisabled ? '0.5' : '1')};
  }
`

// Only spacing between a spinner and its label. Size and padding come from StandardButton's
// own `small` variant, so this button matches every other button in the tab.
export const CheckWithEroButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
`
